import { RootState } from "../../../redux/store";
import { computeDecision } from "./benefits.domain";
import { EBenefitTypes, EShowMode } from "../enums/benefits.enums";
import { Entitlement, GuardDecision } from "../types/benefits.types";

export const selectBenefitsStatus = (s: RootState) => s.benefits.status;
export const selectBenefitsLoadedAt = (s: RootState) => s.benefits.loadedAt;

// SI EL BENEFICIO EN EL ENDPOINT TIENE ESTAS PROPIEDADES, USAR ESTOS SELECTORES
//   const ent = useAppSelector(selectEntitlement(EBenefitTypes.AREASCOVERAGES));

//   const usageCount = ent?.used ?? 0;          // <- usageCount
//   const limit = ent?.limit;                  // <- limitedUsage (si aplica)
//   const remaining = ent?.remaining;          // <- lo que queda
//   const canUseNow = ent?.canUseNow ?? false; /// <- si se puede usar ahora

//   console.log(usageCount, limit, remaining, canUseNow)

export const selectEntitlement =
    (type: EBenefitTypes) =>
        (s: RootState): Entitlement | undefined =>
            s.benefits.byType[type];

export const selectDecision =
    (type: EBenefitTypes, showWhenBlocked: EShowMode) =>
        (s: RootState): GuardDecision =>
            computeDecision(s.benefits.byType[type], showWhenBlocked);